import { render, staticRenderFns } from "./addClassification.vue?vue&type=template&id=521466a4&scoped=true&"
import script from "./addClassification.vue?vue&type=script&lang=js&"
export * from "./addClassification.vue?vue&type=script&lang=js&"
import style0 from "./addClassification.vue?vue&type=style&index=0&id=521466a4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "521466a4",
  null
  
)

export default component.exports